import { DataBean } from "../DataBean";

export class DashBoardAccountCatalog extends DataBean {



    public async getDashBoardAccountCatalog(idDashBoard: any, idAccount: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getDashBoardAccountCatalog_Number_Number_Number_Number", [idDashBoard, idAccount, page, recordsPerPage]);
    }
    public async deleteDashBoardAccount(idDashBoardAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteDashBoardAccount_Number", [idDashBoardAccount]);
    }
}
